import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part13 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 5;
	chapterIds = {		
		scenario4_5C_s23: 'CALM - Scenario 4 - 5C - Segment 23',
		scenario4_5C_s24: 'CALM - Scenario 4 - 5C - Segment 24',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}


	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part13.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();
	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(this.chapterIds.scenario4_5C_s23, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C04-L3-030a',
			[{
				text: 'Bring the form back to the Ward Clerk.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1GoToNSC(), context.partIndx);
			}
		);
		context.scenario.updateObjective('');
	}

	private segment3Step1GoToNSC() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_5C_s24, () => {
			context.segment3Step2EnterReports();
		});
	}

	private segment3Step2EnterReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report.'
				},
				{
					title: '24 Hour',
					description: 'Nothing to add to report.'
				},
				{
					title: 'End of Shift',
					description: 'Nothing to add to report.'
				}
			],
			review: {
				text:
					`
						<p class="regular-description-font" style="margin: 0;">	
						Staff look to Charge Nurses to help them when questions or problems arise. In our case, RN Miranda needed to 
						know how to help Mr. Zolic obtain a Release of Information form to request records from this hospitalization. <br /><br />

						While answering your staff’s questions is always desirable and shows support, at some point, it may 
						<span style="color: rgb(222, 225, 156)">become necessary that someone else handle an issue for you.</span> You will 
						need to prioritize issues that demand Charge Nurse intervention and those that others can address for you. <br /><br />

						Furthermore, as a Charge Nurse, you are exposed to competing priorities that may need to be addressed. In our case, 
						RN Miranda seeks continuous guidance. New graduates require ongoing support after preceptorship is completed; 
						<span style="color: rgb(222, 225, 156)">assigning a mentor is one way to provide continuing direction. </span>					
						</p>
						`
			},
			reflects: [
				{
					title: 'Where is the medical records department located in your facility?',
					answer: ''
				},
				{
					title: 'Where do you keep Release of Information forms?',
					answer: ''
				},
				{
					title: 'What kinds of resources do you have available at your unit to help with this type of request?',
					answer: ''
				},
				{
					title: 'What if the Ward Clerk was not present when the Release of Information was to be submitted?  How would you handle this situation?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {			
			context.scenario.gameManager.UiManager.destroyAllInstances();
			context.onDone();
		});
	}
}